import type { ArenaZone, DropType, Obstacle } from './types';

export const GAME = {
  width: 1200,
  height: 720,
  fixedDt: 1 / 60,
  maxCatchUpSteps: 5,
  matchDuration: 7 * 60,
  suddenDeathDuration: 45,
  coreHealth: 100,
  coreRadius: 40,
  spawnInterval: 0.5,
  unitRadius: 7,
  unitMinRadius: 2.4,
  unitHealth: 100,
  unitSpeed: 60,
  maxUnits: 650,
  neighborRadius: 54,
  collisionRadius: 14.5,
  contactDamage: 40,
  contactCooldown: 0.24,
  contactBounce: 76,
  inventoryCapacity: 7,
  deliveryInterval: 10,
  overflowDuration: 5,
  previewCount: 3,
  aiThinkInterval: 1.15,
  decayDuration: 1.5,
  effect: {
    attractor: { radius: 215, duration: 18, force: 170 },
    deflector: { radius: 185, duration: 14, force: 235 },
    speed: { radius: 180, duration: 11, multiplier: 2.1 },
    explosion: { radius: 105, warning: 0.95, duration: 1.8 },
    surge: { count: 16 },
  },
} as const;

export const OBSTACLES: readonly Obstacle[] = [
  { x: 470, y: 205, radius: 48 },
  { x: 730, y: 205, radius: 48 },
  { x: 470, y: 515, radius: 48 },
  { x: 730, y: 515, radius: 48 },
  { x: 600, y: 360, radius: 34 },
];

export const ARENA_ZONES: readonly ArenaZone[] = [
  { type: 'forge', x: 600, y: 112, radius: 84 },
  { type: 'shield', x: 600, y: 608, radius: 84 },
  { type: 'decay', x: 600, y: 360, radius: 96 },
];

export const DROP_LABELS: Record<DropType, string> = {
  attractor: 'Attractor',
  deflector: 'Deflector',
  speed: 'Speed',
  explosion: 'Explosion',
  surge: 'Surge',
};

export const DROP_SHORTCUTS: Record<DropType, string> = {
  attractor: '1',
  deflector: '2',
  speed: '3',
  explosion: '4',
  surge: '5',
};
